import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts'

// Truncate HTS code for display
function formatHTSCode(code) {
  // Show only first 6 digits for chart
  const clean = code.replace(/[^0-9]/g, '')
  if (clean.length >= 6) {
    return `${clean.slice(0, 4)}.${clean.slice(4, 6)}`
  }
  return code
}

export default function HTSDistributionChart({ data }) {
  const chartData = Object.entries(data)
    .map(([code, count]) => ({
      code,
      shortCode: formatHTSCode(code),
      count: Number(count),
    }))
    .sort((a, b) => b.count - a.count)
    .slice(0, 10) // Top 10

  // Color gradient from so-green to so-orange
  const getBarColor = (index, total) => {
    if (total <= 1) return '#1e5045'
    const ratio = index / (total - 1)
    // Interpolate between so-green (#1e5045) and so-orange (#f26522)
    if (ratio < 0.5) {
      return '#1e5045'
    } else if (ratio < 0.75) {
      return '#94c43d'
    } else {
      return '#f26522'
    }
  }

  return (
    <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={chartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 60 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis
            dataKey="shortCode"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11 }}
            angle={-45}
            textAnchor="end"
            height={60}
          />
          <YAxis
            axisLine={false}
            tickLine={false}
            allowDecimals={false}
          />
          <Tooltip
            formatter={(value, name, props) => [
              `${value} component${value !== 1 ? 's' : ''}`,
              props.payload.code,
            ]}
            labelFormatter={() => 'HTS Code'}
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
            }}
          />
          <Bar dataKey="count" radius={[4, 4, 0, 0]}>
            {chartData.map((_, index) => (
              <Cell
                key={`cell-${index}`}
                fill={getBarColor(index, chartData.length)}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
